/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Lifecycle status of a gamification model instance
 * @export
 */
export const GamificationStatus = {
    DRAFT: 'DRAFT',
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED',
    COMPLETED: 'COMPLETED',
    ARCHIVED: 'ARCHIVED'
} as const;
export type GamificationStatus = typeof GamificationStatus[keyof typeof GamificationStatus];


export function instanceOfGamificationStatus(value: any): boolean {
    for (const key in GamificationStatus) {
        if (Object.prototype.hasOwnProperty.call(GamificationStatus, key)) {
            if (GamificationStatus[key as keyof typeof GamificationStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GamificationStatusFromJSON(json: any): GamificationStatus {
    return GamificationStatusFromJSONTyped(json, false);
}

export function GamificationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): GamificationStatus {
    return json as GamificationStatus;
}

export function GamificationStatusToJSON(value?: GamificationStatus | null): any {
    return value as any;
}

export function GamificationStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): GamificationStatus {
    return value as GamificationStatus;
}

